import React from 'react';
import "./AccountTable.scss";
import CommonTable from "../../../../components/common/CommonTable/CommonTable.jsx";
import { toFix } from '../../../../helpers/commonHelper';
const AccountTable = ({
  walletList
}) => {
  const fields = ['Asset', 'Balance', 'Allocated', 'Available'];
  return <>
            <div className='accountTable'>
                <CommonTable fields={fields}>
                    {walletList?.map((item, index) => {
          const total = Number(item.total_balance ?? item.totalBalance ?? 0);
          const available = Number(item.available_balance ?? item.availableBalance ?? 0);
          const allocated = total - available;
          const assetName = item.asset_name ?? item.assetName;
          return <tr key={`${assetName}-${index}`}>
                            <td>{assetName}</td>
                            <td>{toFix(total, 4)}</td>
                            <td>{toFix(allocated, 4)}</td>
                            <td>{toFix(available, 4)}</td>
                        </tr>;
        })}
                </CommonTable>
            </div>
        </>;
};
export default AccountTable;